import { Box, LinearProgress, Fade, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import lsLogo from "../assets/LegalStreamLogo.avif";

const LsPageLoader = ({ fullScreen = false, message = null }) => {
    const theme = useTheme();

    return (
        <Fade in timeout={300}>
            <Box
                sx={{
                    height: fullScreen ? "100vh" : "100%",
                    minHeight: fullScreen ? "100vh" : "400px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.3)", // More transparent
                    backdropFilter: "blur(10px)", // Frosted glass effect
                    gap: 3,
                }}
            >
                {/* Logo with pulse animation */}
                <Box
                    sx={{
                        animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
                        "@keyframes pulse": {
                            "0%, 100%": {
                                opacity: 1,
                            },
                            "50%": {
                                opacity: 0.6,
                            },
                        },
                    }}
                >
                    <img
                        src={lsLogo}
                        alt="Loading"
                        style={{
                            height: "80px",
                            objectFit: "contain",
                        }}
                    />
                </Box>

                {/* Progress bar */}
                <Box sx={{ width: "200px" }}>
                    <LinearProgress
                        sx={{
                            height: 3,
                            borderRadius: 2,
                            backgroundColor: theme.palette.grey[200],
                            "& .MuiLinearProgress-bar": {
                                borderRadius: 2,
                                backgroundColor: theme.palette.primary.main,
                            },
                        }}
                    />
                </Box>

                {/* Optional message */}
                {message && (
                    <Typography
                        variant="body2"
                        sx={{
                            color: "text.secondary",
                            fontSize: "0.875rem",
                            fontWeight: 500,
                            textAlign: "center",
                            px: 2,
                        }}
                    >
                        {message}
                    </Typography>
                )}
            </Box>
        </Fade>
    );
};

export default LsPageLoader;